import WalletIcon from 'assets/images/wallet-icon.svg';

const NotConnectedContent = () => {
  return (
    <div className="orders-table-empty">
      <div className="orders-table-empty-img">
        <img src={WalletIcon} alt="wallet" />
      </div>
      <p className="orders-table-empty-text">{_t('Wallet not connected', 'VIEW_ORDERS.WALLET_NOT_CONNECTED')}</p>
    </div>
  );
};

export default NotConnectedContent;
